<template>
  <div class="toast" v-show="show">
    <div class="icon"></div>
    <p class="msg">
      {{msg}}
    </p>
  </div>
</template>

<script>
export default {
  name: "toast",
  data() {
    return {
      show: true,
      msg: ""
      // time: 3000,
      // countDown: null
    };
  },
  methods: {
    open(m) {
      this.msg = m;
      // this.time = t || this.time
      this.show = true;
      // this.countDown = setTimeout(() => {
      //   this.close()
      // }, this.time)
    },
    close() {
      this.show = false;
    }
  }
};
</script>

<style lang="less" scoped>
.toast {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 20%;
  bottom: 0;
  left: 20%;
  margin: auto;
  height: 80px;
  width: 250px;
  text-align: center;
  color: #fff;
  border-radius: 4px;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.8);

  .icon {
    width: 20px;
    height: 20px;
    background: url('../../assets/img/common/complete.png') no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    margin-bottom: 10px;
  }
  .msg {
    display: inline-block;
    white-space: nowrap;
    border-radius: 4px;
    padding: 0 56px;
    width: max-content;
    color: #fff;
    font-size: 14px;
  }
}
</style>
